import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearPageState, setPageState } from "../../redux";
import { PageState } from "../../redux/emptyStates/PagePersisting";
import { forceReloadIframe } from "../../redux/iframeActions";
interface PersistentLinkProps {
  to: string;
  state?: any;
  resetOnNavigate?: boolean;
  persistingData?: PageState;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const PersistentLink: React.FC<PersistentLinkProps> = ({
  to,
  state,
  resetOnNavigate = false,
  persistingData,
  children,
  className,
  onClick,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    onClick?.();
    if (resetOnNavigate) {
      dispatch(clearPageState({ pathname: to }));
      dispatch(forceReloadIframe());
    }
    if (persistingData) {
      dispatch(setPageState({ pathname, pageState: persistingData }));
    }
    navigate(to, {state: state});
  };

  return (
    <a href={to} onClick={(e) => handleClick(e)} className={className}>
      {children}
    </a>
  );
};

export default PersistentLink;
